import React from 'react';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster } from 'sonner';

import { CommonErrorBoundary } from '../../src/common/components/common-error-boundary.tsx';
import { CommonSuspenseFallback } from '../../src/common/components/common-suspense-fallback.tsx';
import { AbortControllerProvider } from '../../src/common/providers/abort-controller-provider.tsx';
import { CurrentEnvironment } from '../../src/environment/components/current-environment.tsx';
import { MainRouter } from '../../src/main/routers/main.router.tsx';
import { MainPersistStore, MainStore } from '../../src/main/store/main.store.ts';

import { setupPreloadErrorHandler } from './preload-error-handler';

import '../../src/index.css';
import '../../src/main/locale/setup.ts';

setupPreloadErrorHandler();

export const CommonEntrypoint: React.FC = () => {
  return (
    <StrictMode>
      <CommonErrorBoundary>
        <Provider store={MainStore}>
          <PersistGate loading={<CommonSuspenseFallback />} persistor={MainPersistStore}>
            <AbortControllerProvider>
              <Toaster closeButton />
              <MainRouter />
              <CurrentEnvironment />
            </AbortControllerProvider>
          </PersistGate>
        </Provider>
      </CommonErrorBoundary>
    </StrictMode>
  );
};
